import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { SupplierDialog } from "./SupplierDialog";
import { TableBox } from "./TableBox";
import { MaterialDiolog } from "./MaterialDialog";
import { useSupplierOfferModel } from "./supplierOfferModel";


export const SupplierPrice: FC<RouterParamType> = (detailsInfo) => {
    const { enquiryCode, setDtpCode } = useSupplierOfferModel(({ enquiryCode }) => [enquiryCode]);

    //每次进入tab页签  准确拿到对应询价单得code， 关闭得时候清空
    useEffect(() => {
        setDtpCode(detailsInfo.id);
        return () => {
            setDtpCode("")
        }
    }, [])
    return (
        <>
            {enquiryCode && <>
                <TableBox {...detailsInfo} />
                <SupplierDialog {...detailsInfo} />
                <MaterialDiolog {...detailsInfo} />
            </>}
        </>
    )
}